// extracted by mini-css-extract-plugin
export default {"quick":"ShoesProductsInfo_quick__kNRcV","image":"ShoesProductsInfo_image__BX4uC"};